/** 一覧 → 詳細のスクロール復元用（廃止）の残骸を消す */
const POSTER_LIST_SCROLL_KEY = 'tinyIdentity_posterListScroll';

export const scrollWindowToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
};

/** 旧バージョンで保存されたスクロール位置を削除 */
export const clearPosterListScrollPosition = () => {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(POSTER_LIST_SCROLL_KEY);
  } catch (_) {
    /* ignore */
  }
};
